
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M11 22H13V24H11V22ZM7 22H9V24H7V22ZM15 22H17V24H15V22ZM13.41 10L17.03 6.38004C17.22 6.19004 17.32 5.94004 17.32 5.67004C17.32 5.40004 17.21 5.15004 17.03 4.96004L12.7 0.650035C12.41 0.360035 11.98 0.280035 11.61 0.430035C11.24 0.580035 11 0.950035 11 1.35004V7.58004L7.14 3.73004C6.75 3.34004 6.12 3.34004 5.73 3.73004C5.34 4.12004 5.34 4.75004 5.73 5.14004L10.58 10L5.73 14.85C5.34 15.24 5.34 15.87 5.73 16.26C6.12 16.65 6.75 16.65 7.14 16.26L11 12.41V18.64C11 19.04 11.24 19.41 11.62 19.56C11.74 19.61 11.87 19.64 12 19.64C12.26 19.64 12.52 19.54 12.71 19.35L17.03 15.03C17.22 14.84 17.32 14.59 17.32 14.32C17.32 14.05 17.21 13.8 17.03 13.61L13.41 10ZM13 3.77004L14.91 5.68004L13 7.58004V3.77004ZM13 16.23V12.41L14.91 14.32L13 16.23Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-settings-bluetooth`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSettingsBluetooth

    ```js
    <b-new-b-icon-settings-bluetooth />
    ```
</docs>


